import React, { Component } from 'react';
import ReadAxios from "../axiosComponent/read";
import isEmpty from "lodash/isEmpty";

export default class Destinationrender extends Component {
  constructor(props) {
    super(props);

    this.state = {
      routeDetail: [],
    };
  }

  async componentDidMount() {
    let route_id = this.props.data.route_id ? this.props.data.route_id : (this.props.data.shipment ? this.props.data.shipment.route_id : "")
    let dataArray =
      (await ReadAxios({
        url: `routeManager/${route_id}`,
      })) || [];
    dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    this.setState({ routeDetail: dataArray || [] });
  }
  render() {
    const { t } = this.props;
    const { routeDetail } = this.state;
    return (
      <div>
        <span>{routeDetail.length > 0 ? routeDetail[routeDetail.length - 1].checkPointName : "NA"}</span>
      </div>
    )
  }
}
